export default "__VITE_ASSET__ClX6s4la__"